import { Navigate, Outlet, useLocation } from "react-router-dom";
import { usePermissions } from "@/hooks/usePermissions";

/**
 * Org employees: Studio is consumption-only — bundles list, read-only bundle detail, and player.
 * Library / wizard routes redirect to bundles.
 */
export function StudioEmployeeGuard() {
  const { isEmployee } = usePermissions();
  const { pathname } = useLocation();

  if (!isEmployee) return <Outlet />;

  if (pathname.startsWith("/studio/player/")) return <Outlet />;
  if (pathname.startsWith("/studio/videos/")) return <Outlet />;
  if (pathname === "/studio/bundles" || pathname === "/studio/bundles/") return <Outlet />;

  const bundleDetail = /^\/studio\/bundles\/[^/]+$/.test(pathname);
  if (bundleDetail) return <Outlet />;

  return <Navigate to="/studio/bundles" replace />;
}
